module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conf-warp"
  }, [(_vm.showHard) ? _c('div', {
    staticClass: "conf-hard"
  }, [_c('p', {
    staticStyle: {
      "width": "80px",
      "margin": "0",
      "color": "#333"
    }
  }, [_vm._v("初始难度")]), _vm._v(" "), _c('span', {
    staticClass: "diff-reduce",
    on: {
      "click": _vm.redHard
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "conf-slider"
  }, [_c('mu-slider', {
    staticClass: "demo-slider",
    attrs: {
      "max": _vm.max,
      "min": _vm.min,
      "step": 1
    },
    on: {
      "input": _vm.changeSlide
    },
    model: {
      value: (_vm.hard),
      callback: function($$v) {
        _vm.hard = $$v
      },
      expression: "hard"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rainbow-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "diff-plus",
    on: {
      "click": _vm.addHard
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "-26px",
      "top": "-14px",
      "width": "40px",
      "height": "40px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hard),
      expression: "hard"
    }],
    staticClass: "conf-choose-hard",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hard)
    },
    on: {
      "keyup": _vm.inputHard,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hard = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "hard-line"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightHard),
      expression: "rightHard"
    }],
    staticStyle: {
      "position": "absolute",
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("请输入" + _vm._s(_vm.min) + "~" + _vm._s(_vm.max) + "范围内的数值")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "conf-time"
  }, [_c('p', {
    staticStyle: {
      "line-height": "50px",
      "width": "80px",
      "margin": "0",
      "color": "#333"
    }
  }, [_vm._v("训练时长")]), _vm._v(" "), _c('div', {
    staticClass: "choose-time-wrap"
  }, [_c('div', {
    staticClass: "conf-reduce",
    on: {
      "click": _vm.redTime
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.time),
      expression: "time"
    }],
    staticClass: "conf-choose-day",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.time)
    },
    on: {
      "keyup": _vm.inputTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.time = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "conf-plus",
    on: {
      "click": _vm.addTime
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "12px",
      "right": "0",
      "color": "#333"
    }
  }, [_vm._v("分钟")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightTime),
      expression: "rightTime"
    }],
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("请输入1~60范围内的数值")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1925bb9d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/selectLevel.vue
// module id = 957
// module chunks = 2